<template>
    <div class="content" v-loading.fullscreen.lock="fullscreenLoading">
        <!-- start of title -->
        <div class="title-box">
            <el-button type="default" size="mini" @click="goBack">返回</el-button>
            <span>结算单审批</span>
        </div>
        <!-- end of title -->

        <!-- start of form -->
        <div class="form-box" v-if="formData">
            <div id="printBill">
                <!-- start of 结算单信息 -->
                <div style="position: relative;" class="back-color-fff mt-4">
                    <span class="form-title">结算单信息</span>
                    <span class="form-title" v-if="formData.approveVO&&formData.approveVO.flowNo">- {{ formData.approveVO.flowNo }}</span>
                    <el-row :gutter="24">
                        <el-col :span="24" class="base-box" v-if="formData.targetType === 2">
                            <span class="label">{{reportName}}：</span>
                            <div class="file-img-box">
                                <span>{{ formData.relevance || '-' }}</span>
                                <a  class="file-preview" @click="see(formData.filePath)">查看详情</a>
                            </div>
                        </el-col>
                        <!-- <el-col :span="12" class="base-box">
                            <span class="label">关联服务商：</span>
                            <div> {{ formData.servicerName||formData.serviceTenantName||'-' }}</div>
                        </el-col> -->
                        <el-col :span="5" class="base-box mt-10">
                            <span class="label">结算日期<el-tooltip class="item" effect="dark" content="结算时间为支付给平台服务人员的时间" placement="right-start"><i class="el-icon-question"></i></el-tooltip>：</span>
                            <div> {{ formData.settleDate | getDate }}</div>
                        </el-col>
                        <el-col :span="5" class="base-box mt-10">
                            <span class="label">申请盖章：</span>
                            <div> {{ formData.isStampApply == 'Y' ? '是' : '否' }}</div>
                        </el-col>
                        <el-col :span="5" class="base-box mt-10">
                            <span class="label">结算金额合计：</span>
                            <div><span style="color: #FF5F1F;">{{ formData.settleAmount | numFmt | numDigit }}</span>元</div>
                        </el-col>
                        <el-col :span="5" class="base-box mt-10">
                            <span class="label">结算总额合计：</span>
                            <div> <span style="color: #FF5F1F;">{{ formData.totalAmount|adjustFilter(false,formData.settleDetail,approveState) | numFmt | numDigit}}</span>元</div>
                        </el-col>
                        <el-col v-if="formData.settleHedgeGuid" :span="24" class="base-box mt-10">
                            <span class="label" style="width:140px">关联结算单对冲流程：</span>
                            <div class="file-img-box">
                                <span>{{ formData.relevanceHedge || '-' }}</span>
                                <a  class="file-preview" @click="seeHedge(formData.filePath)">查看详情</a>
                            </div>
                        </el-col>
                         <el-col :span="24" class="base-box mt-10">
                            <span class="label">备注：</span>
                            <div class="file-img-box">
                                <span style="color: red;">{{ formData.memo }}</span><span>{{ formData.memo ?'': '-' }}</span>
                            </div>
                        </el-col>
                    </el-row>
                    <img  v-if="formData.isHedge=='Y'"  class="duichong-img" src="@/assets/images/ic_duichong.png" alt="" srcset="">
                    <img
                        v-show="formData.approveVO && formData.approveVO.approveState !== 'N'"
                        class="approve-img"
                        :src="getApproveImg()"
                        alt=""
                    />
                </div>
                <!-- end of 结算单信息 -->

                <section v-for="(item, index) in formData.settleDetail" :key="index">
                    <template v-if="formData.targetType === 1">
                        <div class="back-color-fff mt-4" v-if="(item.taskType === '品牌推广'||item.taskType === '市场调研') && item.taskType !== '数据采集' && index === 0">
                            <el-row style="padding-top:20px" :gutter="24">
                                <el-col :span="24" class="base-box">
                                    <span class="label">{{reportName}}：</span>
                                    <div class="file-img-box">
                                        <span>{{ formData.relevance || '-' }}</span>
                                        <a  class="file-preview" @click="see(formData.filePath)">查看详情</a>
                                    </div>
                                </el-col>
                            </el-row>
                        </div>
                    </template>
                    <!-- start of 结算单 -->
                    <div class="back-color-fff mt-4 pb-16">
                        <div class="form-title-box" id="title" style="width:850px;">
                            <span class="form-title">{{ item.taskType }}结算单</span>
                            <div>
                                <el-button type="info" size="mini" @click="billPrintClick(item,2)"
                                    id="printBtn">二合一打印</el-button>
                                <el-button type="info" size="mini" @click="billPrintClick(item,0)"
                                    id="printBtn">打印{{ item.taskType }}结算单</el-button>
                            </div>
                        </div>
                        <!-- 市场推广结算单 -->
                        <div class="content-main-box detail-box" :id="'baseInfo' + index" style="overflow: hidden;">
                            <h2 style="width:800px;">{{ item.taskType }}结算单</h2>
                            <p >尊敬的客户:</p>
                            <p>根据贵公司与我司所签订的服务协议，请贵公司确认以下费用明细，并进行相关款项支付，谢谢。</p>
                            <p style="width:800px;" class="txt-right">结算日期：{{ formData.settleDate
                                | getDate }}</p>

                            <!-- 本期应付款总结算明细 -->
                            <div class="table1" style="width:800px;">
                                <div class="header-div">本期应付款总结算明细</div>
                                <div class="flex-between">
                                    <div class="tab-label">本期应付款合计金额(小写)：</div>
                                    <div class="tab-value" style="color: #FF5F1F;">¥{{ item.totalAmount|adjustFilter(item.mantissaAmount,[],approveState) | numFmt | numDigit
                                    }}</div>
                                </div>
                                <div class="flex-between">
                                    <div class="tab-label">本期应付款合计金额(大写)：</div>
                                    <div class="tab-value">{{ item.totalAmount|adjustFilter(item.mantissaAmount,[],approveState) | smallToBig }}</div>
                                </div>
                            </div>

                            <table class="table2" cellpadding="0" cellspacing="0" style="width:800px;">
                                <thead>
                                    <th style="text-align: center;width:90px">序号</th>
                                    <th style="text-align: center;width:210px">结算内容</th>
                                    <th style="text-align: center;width:150px">结算结果</th>
                                    <th style="border-right: 1px solid rgba(229, 229, 229, 1);text-align: center;">结果说明</th>
                                </thead>
                                <tr>
                                    <td style="text-align: center;">1</td>
                                    <td >结算金额(元)</td>
                                    <td style="text-align: right;">{{ item.realSettleMoney | numFmt | numDigit }}</td>
                                    <td>个人结算明细表</td>
                                </tr>
                                <tr style="background:#FAFAFA">
                                    <td style="text-align: center;">2</td>
                                    <td>结算人数(个)</td>
                                    <td style="text-align: right;">{{ item.personNum }}</td>
                                    <td>详见结算明细表</td>
                                </tr>
                                <tr>
                                    <td style="text-align: center;">3</td>
                                    <td>服务费(元)</td>
                                    <td style="text-align: right;">{{ item.serviceAmount | numFmt | numDigit }}</td>
                                    <td>服务费费率，{{ formData.cooperationTaxRate + '%' }}</td>
                                </tr>
                                <tr>
                                    <td style="text-align: center;">4</td>
                                    <td>尾数调整(元)</td>
                                    <td style="text-align: right;">
                                        <el-input-number :disabled="approveState!='N'" :precision="2" :controls="false" placeholder="请输入" v-model.trim="item.mantissaAmount">
                                        </el-input-number>
                                        <!-- <el-input
                                            type="text"
                                            class="adjust-input"
                                            :disabled="approveState!='N'"
                                            onkeyup="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')"
                                            maxlength="12"
                                            v-model="item.mantissaAmount"
                                            @blur="item.mantissaAmount = $event.target.value"
                                            placeholder="请输入"
                                            /> -->
                                    </td>
                                    <td></td>
                                </tr>
                                <tr style="background:#FAFAFA">
                                    <td style="text-align: center;">5</td>
                                    <td>结算总额(元)</td>
                                    <td style="text-align: right;" >{{ item.totalAmount|adjustFilter(item.mantissaAmount,[],approveState) | numFmt | numDigit }}</td>
                                    <td>结算金额+服务费金额+尾数调整</td>
                                </tr>

                            </table>

                            <div style="display: flex;" >
                                <!-- start of 贵公司账户信息 -->
                                <div class="info-box">
                                    <p>贵公司账户信息如下：</p>
                                    <table class="table2" cellpadding="0" cellspacing="0">
                                        <tr>
                                            <th style="border-bottom: 0 none;width:80px;">开户名称：</th>
                                            <td class="font-normal" style="border-top: 1px solid rgba(229, 229, 229, 1);">
                                                {{ item.serviceTenantContractBank && item.serviceTenantContractBank.tenantName || '-' }}
                                            </td>
                                        </tr>
                                    
                                        <tr>
                                            <th style="border-bottom: 0 none;">开户银行：</th>
                                            <td class="font-normal">{{ item.serviceTenantContractBank && item.serviceTenantContractBank.bankName || '-' }}</td>
                                        </tr>
                                        <tr>
                                            <th style="border-bottom: 0 none;">银行账号：</th>
                                            <td class="font-normal">{{ item.serviceTenantContractBank && item.serviceTenantContractBank.bankAccount || '-' }}
                                            </td>
                                        </tr>
                                        <tr>
                                            <th style="border-bottom: 0 none;">公司税号：</th>
                                            <td class="font-normal">{{ item.serviceTenantContractBank && item.serviceTenantContractBank.bankTaxNo || '-' }}</td>
                                        </tr>
                                        
                                        <tr>
                                            <th style="border-bottom: 0 none;">公司电话：</th>
                                            <td class="font-normal">{{ item.serviceTenantContractBank && item.serviceTenantContractBank.tel || '-' }}</td>
                                        </tr>
                                        <tr>
                                            <th >公司地址</th>
                                            <td class="font-normal" style="height:40px">{{ item.serviceTenantContractBank && item.serviceTenantContractBank.address || '-' }}</td>
                                        </tr>
                                        <!-- <tr>
                                            <th style="border-bottom: 0 none;width:80px;">开户名称：</th>
                                            <td style="border-top: 1px solid rgba(229, 229, 229, 1);">
                                                {{ item.serviceTenantContractBank&&item.serviceTenantContractBank.tenantName || '-' }}</td>
                                        </tr>
                                        <tr >
                                            <th style="border-bottom: 0 none;">开户银行：</th>
                                            <td>{{ item.serviceTenantContractBank&&item.serviceTenantContractBank.bankName || '-' }}</td>
                                        </tr>
                                        <tr>
                                            <th>银行账号：</th>
                                            <td>{{ item.serviceTenantContractBank&&item.serviceTenantContractBank.bankAccount || '-' }}</td>
                                        </tr> -->
                                    </table>
                                  
                                </div>
                                <!-- end of 贵公司账户信息 -->

                                <!-- start of 我方账户信息 -->
                                <div class="info-box" style="margin-left:20px">
                                    <p>我方账户信息如下：</p>
                                    <table class="table2" cellpadding="0" cellspacing="0">
                                        
                                        <tr>
                                            <th style="border-bottom: 0 none;width:80px;">开户名称：</th>
                                            <td class="font-normal" style="border-top: 1px solid rgba(229, 229, 229, 1);">
                                                {{ item.tenantContractBank && item.tenantContractBank.tenantName || '-' }}
                                            </td>
                                        </tr>
                                   
                                        <tr>
                                            <th style="border-bottom: 0 none;">开户银行：</th>
                                            <td class="font-normal">{{ item.tenantContractBank && item.tenantContractBank.bankName || '-' }}</td>
                                        </tr>
                                        <tr>
                                            <th style="border-bottom: 0 none;">银行账号：</th>
                                            <td class="font-normal">{{ item.tenantContractBank && item.tenantContractBank.bankAccount || '-' }}
                                            </td>
                                        </tr>
                                      
                                        <tr>
                                            <th style="border-bottom: 0 none;">公司税号：</th>
                                            <td  class="font-normal">{{ item.tenantContractBank && item.tenantContractBank.bankTaxNo || '-' }}</td>
                                        </tr>
                                        <tr>
                                            <th style="border-bottom: 0 none;">公司电话：</th>
                                            <td  class="font-normal">{{ item.tenantContractBank && item.tenantContractBank.tel || '-' }}
                                            </td>
                                        </tr>
                                        <tr>
                                            <th >公司地址</th>
                                            <td   class="font-normal" style="height:40px">{{ item.tenantContractBank && item.tenantContractBank.address || '-' }}</td>
                                        </tr>
                                     
                                    </table>
                                </div>
                                <!-- end of 我方账户信息 -->
                            </div>

                            <!-- <p>如有任何疑问，请与我司药企服务事业部 {{ formData.applyStaffName }} 进行联系，谢谢！</p> -->
                            <div style="width:800px;line-height: 35px;margin-bottom: 15px;">
                                <div class="info-box">贵公司对接人：<span class="font-normal">{{formData.applyStaffName}}</span></div>
                                <div class="info-box">我司对接人：<span class="font-normal">{{formData.tenantContacts}}</span></div>
                            </div>
                            <div class="flex-between"  style="width:800px;">
                                <div class="info-box">盖章处：</div>
                                <div class="info-box">盖章处：</div>
                            </div>
                        </div>
                    </div>
                    <!-- end of 结算单 -->

                    <!-- start of 附件 -->
                    <div class="back-color-fff mt-4 pb-16">
                        <div class="form-title-box" style="width:850px;">
                            <span class="form-title" >{{ item.taskType }}附件</span>
                            <div>
                                <p class="total-tip">结算金额合计：<span>{{getSumAmount( item.settleDetails) | numDigit}}</span>元</p>
                                <el-button type="info" size="mini" @click="billPrintClick(item,1)" id="printBtn">打印{{ item.taskType }}附件</el-button>
                            </div>
                        </div>
                        <div class="content-main-box detail-box" style="overflow: hidden;padding:16px 16px 0px 16px;">
                            <div class="mb-20" :key="index" :id="item.taskTypeGuid" style="width:800px;">
                                <div class="table1" v-if="item.taskType" >
                                    <div class="header-div">附件：{{ item.taskType }}附件明细表</div>
                                </div>
                                <table style="margin-top:0;width:800px;" class="table2" cellpadding="0" cellspacing="0">
                                    <thead style="text-align: center;">
                                        <th style="text-align: center;">序号</th>
                                        <th>姓名</th>
                                        <th>身份证号码</th>
                                        <th>银行卡号</th>
                                        <th>手机号</th>
                                        <!-- <th>任务类型</th> -->
                                        <th>结算金额</th>
                                        <th style="border-right: 1px solid rgba(229, 229, 229, 1);">结算时间</th>
                                    </thead>
                                    <tr v-for="(row, j) in item.settleDetails" :key="j">
                                        <td style="text-align: center;width:40px;">{{ j + 1 }}</td>
                                        <td style="text-align: left;width:60px;">{{ row.staffName }}</td>
                                        <td style="text-align: left;width:140px;">{{ row.idCode || '-' }}</td>
                                        <td style="text-align: left;width:170px;">{{ row.bankAccount || '-' }}</td>
                                        <td style="text-align: left;width:90px;">{{ row.mobileNo || '-' }}</td>
                                        <!-- <td style="text-align: left;width: auto;">{{ row.taskContent || '-' }}</td> -->
                                        <td style="text-align: right;width:120px;">{{ row.actualSettleMoney | numFmt | numDigit }}</td>
                                        <td style="text-align: left;width:100px;">{{ row.settleDate | getDate }}</td>
                                    </tr>
                                </table>
                                <div class="flex-between"  style="width:800px;position: relative;padding: 20px 0;">
                                    <div style="font-weight: bold;position: absolute;right: 140px;">盖章处：</div>
                                </div>
                            </div>

                        </div>
                    </div>
                    <!-- end of 附件 -->
                    <template v-if="formData.targetType === 1">
                        <div class="back-color-fff mt-4" v-if="item.taskType === '数据采集' && (item.taskType !== '品牌推广'||item.taskType !== '市场调研')">
                            <el-row style="padding-top:20px" :gutter="24">
                                <el-col :span="24" class="base-box">
                                    <span class="label">{{reportName}}：</span>
                                    <div class="file-img-box">
                                        <span>{{ formData.relevance || '-' }}</span>
                                        <a  class="file-preview" @click="see(formData.filePath)">查看详情</a>
                                    </div>
                                </el-col>
                            </el-row>
                        </div>
                    </template>
                </section>
                
                


                <!-- start of 流程审批 -->
                <div class="back-color-fff mt-4 pb-16">
                    <!-- <span class="form-title">流程审批</span> -->
                    <div class="flow">
                        <iframe scrolling="no" v-show="iframeSh" :src="iframeSrc" class="iframe-sty"></iframe>
                    </div>
                </div>
                <!-- end of 流程审批 -->
            </div>

            <!-- start of bottom-btn -->
            <div class="back-color-fff submit_btn_wrap">
                <el-button type="defalut" class="cannel-btn" size="mini" @click="goBack">取消</el-button>
                <el-button type="danger" size="mini" v-show="getBtnState('approval') == 'approval'"
                    @click="reject()">驳回</el-button>
                <el-button type="primary" size="mini" v-show="getBtnState('approval') == 'approval'"
                    @click="pass()">通过</el-button>
                <el-button type="primary" size="small" v-show="getBtnState('revoke') == 'revoke'"
                    @click="cancel()">撤销</el-button>
                <!-- <el-button type="primary" size="small" v-show="getBtnState('again') == 'again'" @click="reSubmit()">重新提交</el-button> -->
                <el-button type="defalut" size="mini" v-show="approveState=='N'" @click="submitForm(true)">保存</el-button>
                <el-button type="primary" size="mini" v-show="approveState=='N'" @click="submitForm(false)">提交申请</el-button>
            </div>
            <!-- end of bottom-btn -->
        </div>
        <!-- end of form -->

        <!-- end of dialog-驳回 -->
        <el-dialog title="填写驳回备注" :visible.sync="rejectDialogVisible" width="30%" top="15%">
            <el-input type="textarea" :rows="5" placeholder="输入驳回理由（必填）" v-model="approveSuggest" maxlength="100">
            </el-input>
            <span slot="footer" class="dialog-footer">
                <el-button type="info" class="w100f" @click="toRejectSubmit()">驳回</el-button>
            </span>
        </el-dialog>
        <!-- end of dialog-驳回 -->

        <!-- end of dialog-通过 -->
        <el-dialog title="填写通过备注" :visible.sync="passDialogVisible" width="30%" top="15%">
            <el-input type="textarea" :rows="5" placeholder="请填写通过备注（选填）" v-model="approveSuggest" maxlength="100">
            </el-input>
            <span slot="footer" class="dialog-footer">
                <el-button type="info" class="w100f" @click="toPassSubmit()">通过</el-button>
            </span>
        </el-dialog>
        <!-- end of dialog-通过 -->
        <printDialogCheck
            v-if="showPrint"
            :showPrintDialog.sync="showPrint"
            :printData="printData"
            :extradata="formData"
            @closePrint="showPrint = false"
            :printType="printType"
        ></printDialogCheck>
        
    </div>
</template>
  
<script>
import printDialogCheck from './components/printCost.vue';
import { bpmnroute } from '@/api/apiRoute';
import workFlowCommon from '@/uilt/workFlowCommon';
export default {
    components: {
    printDialogCheck
  },
    data() {
        return {
            that:this,//保存this以便filter中使用
            // mantissaAmount:0,
            printData: null,
            showPrint: false,
            guid: '',
            approveState:'',
            formData: {
                relevance: '',
                settleDate: "",
                isStampApply: "",
                guid: "",
                filePath: ''
            },
            // 开户行
            tenantContractBank: {},
            // 开户行
            serviceTenantContractBank: {},
            fullscreenLoading: false,
            multipleSelection: [],
            tableData: [],
            tableData1: [{
                key: 1,
                taskContent: '结算周期',
                settleAmount: 'settleCycle',
                memo: '任务下发日开始计算，到任务完成日截止',
            }, {
                key: 2,
                taskContent: '结算金额(元)',
                settleAmount: 'settleAmount',
                memo: '个人结算明细表',
            }, {
                key: 3,
                taskContent: '结算人数(个)',
                settleAmount: 'personNum',
                memo: '详见结算明细表',
            }, {
                key: 4,
                taskContent: '服务费(元)',
                settleAmount: 'serviceAmount',
                memo: '服务费费率',
            }, {
                key: 5,
                taskContent: '结算总额(元)',
                settleAmount: 'totalAmount',
                memo: '结算金额+服务费金额',
            }],

            // 关联流程相关
            page: {
                pageIndex: 1,
                pageSize: 50,
                totalRows: 0
            },
            flowLists: [],

            // 流程图相关
            iframeSh: false,
            iframeSrc: '',

            rejectDialogVisible: false,
            passDialogVisible: false,
            approveSuggest: '',
            currentStaffGuid: ''
        };
    },
    created() {
        this.guid = this.$route.query.guid;
        this.approveState=this.$route.query.approveState||'';
        this.getDetailData();
        this.currentStaffGuid = JSON.parse(localStorage.userInfo);
    },
    watch: {},
    filters: {
      adjustFilter(value,amount,list,state) {
        let num = Number(value)
        if(state=='N'){//草稿中的状态才需要加尾数调整
            if(list&&list.length>0){//结算单信息里的结算总额
                list.forEach(item=>{
                    console.log('/',item.mantissaAmount);
                    // let mantissaAmount=Math.floor(Number(item.mantissaAmount)  * 100) / 100
                    let mantissaAmount=Number(item.mantissaAmount)
                    if(mantissaAmount&&!isNaN(item.mantissaAmount)){
                        console.log('p',mantissaAmount);
                        num += mantissaAmount
                    }
                })
            }else{
                if(!isNaN(amount)){
                    // num=Number(value) + Math.floor(Number(amount)  * 100) / 100
                    num=Number(value) + Number(amount)
                }   
            }
            console.log('value',value,amount,list);
        }
        return num
      }
    },
    computed: {
        // 判断是否有质量考核报告 // !优先取质量考核报告, 如果没有则取运营报告
        checkReport() {
            let check = {
                reportGuid :this.formData.operationReportGuidList && this.formData.operationReportGuidList[0] ? this.formData.operationReportGuidList[0] : '' ,
                isQualityApproval : this.formData.targetType === 2 ? true : false
            }
            return check
        },
        reportName() {
            return this.checkReport.isQualityApproval ? '关联质量考核' : '关联运营报告'
        }
    },
    methods: {
        //返回列表
        goBack() {
            this.$router.push({
                path: "/downstreamSettlement",
            });
        },
        // 查看运营报告挪动到 数据采集和品牌推广中间 1.只有数据采集,没有品牌推广 2.没有数据采集,只有品牌推广 3.两个都有
        seeReportPos(key) {
            return this.formData.settleDetail.findIndex(item=>item.taskType === key)
        },
        //状态图片
        getApproveImg() {
            return workFlowCommon.getApproveImg(this.formData.approveVO && this.formData.approveVO.approveState);
        },
        getSumAmount(list){
            let sum = 0;
            list.forEach(item => {
                sum += Math.round(item.actualSettleMoney * 100) / 100 ;
            })
            return sum
        },
        /**
         * 获取详情
         */
        getDetailData() {
            let self = this;
            self.api.get(`/${serverConfig.msSalesPerformService}/downstream/settle/detail/${self.$route.query.guid}`).then((res) => {
                let { code, data, msg } = res.data;
                if (code == serverConfig.REQUIRE_SUCCESS_CODE) {
                    this.formData = data;
                    let accountMonth = data.accountMonth ? JSON.parse(data.accountMonth) : [];
                    // 显示发起人 + 药企简称 + 月份 + 应付金额
                    this.formData['relevance'] =  `${data['applyStaffName']} _ ${data['operationReportTenantName']} _ ${accountMonth.join(' , ')}${(data['currentPayAmount'] ? (' _ ' + this.formatMoney(data['currentPayAmount']) + '(元)') : '')}`
                    this.tenantContractBank = data.tenantContractBank || {};
                    this.serviceTenantContractBank = data.serviceTenantContractBank || {};
                    this.tableData = data.settleDetail || []; // 结算明细
                    this.flowLists = [];
					if (data.settleHedgeGuid) this.getHedgeDetailData(data.settleHedgeGuid) // 关联的金额对冲流程
                    this.getApprovalList();
                    this.getTenantDetail(this.formData.settleDetail[0].tenantContractBank.tenantGuid,1);
                    this.getTenantDetail(this.formData.settleDetail[0].serviceTenantContractBank.tenantGuid,2);
                } else {
                    self.$message.error(msg);
                }
            });
        },
        getHedgeDetailData(settleHedgeGuid) {
            this.api.get(`/${serverConfig.msSalesPerformService}/downstream/settle/hedge/detail/${settleHedgeGuid}`).then((res) => {
                let { code, data, msg } = res.data;
                if (code == serverConfig.REQUIRE_SUCCESS_CODE) {
										this.formData['settleHedgeGuid']
                    let { approveVO } = data
										let accountMonth = data.accountMonth ? JSON.parse(data.accountMonth) : [];
										let paidAmount = data.paidAmount !==null ? `${this.formatMoney(data.paidAmount)}(元)` : ''
          					let returnedAmount = data.returnedAmount !==null ? `${this.formatMoney(data.returnedAmount)}(元)` : ''
                    // 显示发起人 + 药企简称 + 月份 + 应付金额
                    this.formData['relevanceHedge'] = data['applyStaffName'] + ' _ ' + this.formData['operationReportTenantName'] + (paidAmount ? (' _ ' + paidAmount) : '') + (returnedAmount ? (' _ ' + returnedAmount) : '');
                } else {
                    self.$message.error(msg);
                }
            });
        },
        getTenantDetail(tenantGuid,type){
            let req = {
                guid:tenantGuid
            }
            this.api
                .get(`/${serverConfig.msCustomerService}/tenant/data/get-tenant-detail`, req)
                .then((res) => {
                    if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                        if (type == 1) {
                            this.formData.tenantContacts = res.data.data.contacts;
                        }
                        if (type == 2) {
                            this.formData.serviceTenantContacts = res.data.data.contacts;
                        }
                        this.$forceUpdate();
                         console.log( this.formData)
                    } else {
                        this.$message.error(res.data.msg);
                    }
                });

        },
        /**
         * 获取操作按钮显隐
         * @param {*} btnType 
         */
        getBtnState(btnType) {
            if (this.$route.query.approveVO) {
                let userinfo = JSON.parse(localStorage.userInfo);
                let approveVO = JSON.parse(this.$route.query.approveVO)
                return workFlowCommon.getListBtnState(btnType, approveVO.approveState, approveVO.staffGuid, approveVO.approveStaffGuids, userinfo.staffGuid, approveVO.approveState);
            }
        },
        /**
         * 关联流程，查看详情
         */
        see() {
            let approveVO = this.formData.approveVO ? this.formData.approveVO : {}
            let camundaInstanceId = approveVO.camundaInstanceId
            let camundaDeploymentId = approveVO.camundaDeploymentId
            if (this.checkReport.isQualityApproval) {
                this.seeQualityApproval(camundaInstanceId,camundaDeploymentId)
                } else {
                this.seeOperationReport(camundaInstanceId,camundaDeploymentId)
            }
        },
        // 查看质量考核
        seeQualityApproval(camundaInstanceId,camundaDeploymentId) {
            let query = {
                productGuid:this.$route.query.productGuid,
                guid: this.checkReport.reportGuid,
                isDownstream:true,
                //camundaInstanceId:camundaInstanceId,
                //camundaDeploymentId:camundaDeploymentId,
            }
            this.$router.push({
                path: '/qualityApprovalDetail',
                query,
            });
        },
        // 查看运营报告
        seeOperationReport(camundaInstanceId,camundaDeploymentId) {
           let query ={
                productGuid:this.$route.query.productGuid,
                guid: this.checkReport.reportGuid,
                camundaInstanceId:camundaInstanceId,
                camundaDeploymentId:camundaDeploymentId,
                toType:2
            }
            this.$router.push({
                path:'upstreamOperationReportDetail',
                query
            }) 
        },
				/**
         * 关联流程，查看详情
         */
        seeHedge() {
            this.$router.push({
                path:'hedgeAmountDetail',
                query:{
                    productGuid:this.$route.query.productGuid,
                    guid:this.formData.settleHedgeGuid,
                    toType:2
                }
            }) 
        },
        /**
         * 获取流程列表
         */
        getApprovalList() {
            // 00021:结算单流程,00022:付款单流程
            let self = this;
            let userInfo = JSON.parse(localStorage.userInfo);
            let { approveVO } = this.formData;
            if (this.guid && approveVO.camundaInstanceId && approveVO.camundaDeploymentId) {
                this.iframeSrc = bpmnroute + '/iframeBpmn?processInstanceId=' + approveVO.camundaInstanceId + '&camundaDeploymentId=' + approveVO.camundaDeploymentId + '&token=' + localStorage.token;
                this.iframeSh = true;
                this.$forceUpdate()
                return;
            }
            let req = {
                tenantGuid: localStorage.guid,
                flowType: '00021',
                staffGuid: userInfo.staffGuid,
            };
            self.api
                .postJson(`/${serverConfig.msSalesPerformService}/work-flow/data/get-camunda-deployment-id`, req)
                .then((res) => {
                    if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                        if (res.data.data) {
                            self.iframeSh = true;
                            self.iframeSrc = bpmnroute + '/iframeBpmn?camundaDeploymentId=' + res.data.data + '&token=' + localStorage.token;
                            console.log(self.iframeSrc);
                            this.$forceUpdate()
                        } else {
                            self.$message.error('未获取到流程信息');
                        }
                    } else {
                        self.$message.error(res.data.msg);
                    }
                });
        },
        /**
         * 保存
         */
        reject() {
            this.rejectDialogVisible = true;
            this.approveSuggest = '';
        },
        /**
         * 提交
         */
        pass() {
            this.passDialogVisible = true;
            this.approveSuggest = '';
        },
        /**
         * 撤销
         */
        cancel() {
            let self = this;
            let { approveVO } = this.formData;
            this.$confirm('撤销后,该流程将不再进行审核,确定这样操作吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
            }).then(() => {
                let query = {
                    guid: approveVO.approveGuid,
                    flowType: approveVO.flowType,
                    approveStaffGuid: approveVO.staffGuid,
                };
                self.fullscreenLoading = true;
                self.api.postJson(`/${serverConfig.msSalesPerformService}/work-flow/data/canal-flow`, query).then((res) => {
                    if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                        self.fullscreenLoading = false;
                        self.$message.success('撤销成功！');
                        self.$router.go(-1);
                    } else {
                        self.$message.error(res.data.msg);
                    }
                });
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消',
                });
            });
        },
        /**
         * 驳回提交
         */
        toRejectSubmit() {
            if (!this.approveSuggest) {
                return this.$message.error('请填写驳回理由')
            }
            let userInfo = JSON.parse(localStorage.userInfo);
            let { approveVO } = this.formData;
            let query = {
                guid: approveVO.approveGuid,
                flowType: approveVO.flowType,
                approveSuggest: this.approveSuggest,
                approveStaffGuid: userInfo.staffGuid,
            };
            this.fullscreenLoading = true;
            this.api.postJson(`/${serverConfig.msSalesPerformService}/work-flow/data/backup-flow`, query).then((res) => {
                this.fullscreenLoading = false;
                if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                    this.passDialogVisible = false;
                    this.approveSuggest = '';
                    this.$message.success('驳回成功！');
                    this.$router.go(-1);
                } else {
                    this.$message.error(res.data.msg);
                }
            });
        },
        /**
         * 通过提交
         */
        toPassSubmit() {
            let userInfo = JSON.parse(localStorage.userInfo);
            let { approveVO } = this.formData;
            let query = {
                guid: approveVO.approveGuid,
                flowType: approveVO.flowType,
                approveSuggest: this.approveSuggest,
                approveStaffGuid: userInfo.staffGuid,
            };
            this.fullscreenLoading = true;
            this.api.postJson(`/${serverConfig.msSalesPerformService}/work-flow/data/allow-flow`, query).then((res) => {
                this.fullscreenLoading = false;
                if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                    this.passDialogVisible = false;
                    this.approveSuggest = '';
                    this.$message.success('审批通过！');
                    this.$router.go(-1);
                } else {
                    this.$message.error(res.data.msg);
                }
            });
        },
        /**
         * 提交
         */
         submitForm(flag) {
            this.adjustForm(flag)
            
        },
        postFormData(flag) {
            let self = this;
            // if (!this.checkForm()) return;
            let postData = JSON.parse(JSON.stringify(this.formData));
            let userInfo = JSON.parse(localStorage.userInfo);
            // postData['operationReportGuidList'] = [this.currentRowKey]; // !运营报告 guid v4.2.6-8版本停用
            // postData['qualityAssessmentGuidList'] = [this.currentRowKey]; // !质量考核 guid
            // postData['settleDetails'] = this.tableData;
            // postData['serviceTenantGuid'] = localStorage.guid;
            // postData['serviceTenantName'] = userInfo['tenantName'];
            // postData['applyStaffGuid'] = userInfo['userGuid'];
            // postData['applyStaffName'] = userInfo['staffName'];
            // postData['immediateSubmit'] = flag; // false是保存 true是保存并提交
            // postData['settlePaymentBankInfo'] = this.settlePaymentBankInfo[0]
            // postData['settleReceiveBankInfo'] = this.settleReceiveBankInfo
            // postData['settleHedgeGuid'] = this.currentHedgeRowKey // !结算金额对冲流程唯一标识
            let url = 'downstream/settle/add';
            if (this.$route.query.guid) {
                url = 'downstream/settle/update';
                // postData['guid'] = this.$route.query.guid;
                // postData['guidResubmit'] = this.$route.query.type == 2 ? this.$route.query.guid : null;
                postData['guidResubmit'] =  null;
            }
            this.fullscreenLoading = true;
            self.api.postJson(`/${serverConfig.msSalesPerformService}/${url}`, postData).then((res) => {
                this.fullscreenLoading = false;
                if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                    if (flag) {
                        self.$message.success('提交成功！');
                    } else {
                        self.$message.success('保存成功！');
                    }
                    self.$router.go(-1);
                } else {
                    self.$message.error(res.data.msg);
                }
            });
        },
        adjustForm(flag){
            let self=this
            console.log('56',this.formData.settleDetail);
            let data=JSON.parse(JSON.stringify(this.formData.settleDetail));
            let userInfo = JSON.parse(localStorage.userInfo);
            let settleServiceAmountList=[];
            let query={
                applyStaffGuid: userInfo.staffGuid,
                applyStaffName: userInfo.staffName,
                settleGuid: this.formData.guid,
                isUpdateFlag:flag,
                settleServiceAmountList:[],
                qualityAssessmentGuidList:this.formData.operationReportGuidList
            }
            
            if(data.length>0){
                data.forEach(item=>{
                    let obj={
                        taskTypeGuid: item.taskTypeGuid,
                        mantissaAmount: item.mantissaAmount||0,
                        
                    }
                    query.settleServiceAmountList.push(obj)
                })
                console.log('query',query);
            }else return
            
            
            this.fullscreenLoading = true;
            self.api.postJson(`/${serverConfig.msSalesPerformService}/downstream/settle/update/mantissa-amount`, query).then((res) => {
                // this.fullscreenLoading = false;
                if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                    if (flag) {
                        self.$message.success('保存成功！');
                    } else {
                        self.$message.success('提交成功！');
                    }
                    this.$router.go(-1);
                } else {
                    this.fullscreenLoading = false;
                    self.$message.error(res.data.msg);
                }
            });
        },
        checkForm() {
            if (!this.formData.relevance) {
                this.$message.error('关联流程不能为空')
                return false;
            }
            if (!this.formData.settleDate) {
                this.$message.error('结算日期不能为空')
                return false;
            }
            if (!this.formData.isStampApply) {
                this.$message.error('盖章申请不能为空')
                return false;
            }
            try {
                this.tableData.forEach(item => {
                    if (!item.levyCompanyGuid) {
                        throw new Error('供应商不能为空，请批量调整')
                    }
                })
                this.settlePaymentBankInfo.forEach(item => {
                    if (!item.bankName) {
                        throw new Error('请完善贵方银行账号信息')
                    }
                })
                this.settleReceiveBankInfo.forEach(item => {
                    if (!item.bankName) {
                        throw new Error('请完善我方银行账号信息')
                    }
                })
            } catch (e) {
                this.$message.error(e.message);
                return false;
            }


            return true;
        },
        /**
         * 打印
         */
        billPrintClick(printData, printType) {
            printData.tenantContacts = this.formData.tenantContacts;
            printData.serviceTenantContacts = this.formData.applyStaffName;
            printData.approveState = this.approveState;
            this.printData = printData;
            this.printType = printType;
            this.showPrint = true;
            console.log('printData',printData);
            
        },
        /**
         * 数字金额转大写
         * @param {*} num 
         */
        formatMoney(num) {
            // 将数字转换为字符串并保留两位小数
            num = num.toFixed(2);

            // 将字符串按小数点分割成整数部分和小数部分
            var parts = num.toString().split(".");

            // 将整数部分每三位加一个逗号
            parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");

            // 将整数部分和小数部分拼接起来
            return parts.join(".");
        },

    },
};
</script> 
  
<style lang="less" scoped>
.file-preview {
    margin-left: 10px;
    cursor: pointer;
    text-decoration: underline;
    cursor: pointer;
    color: #4fa1a4;
    word-break: keep-all;
}
.content {
    padding: 0px;
    margin: 0px;
    overflow-x: hidden;

    .title-box {
        border-top: 1px solid #E5E5E5;
        background-color: #ffffff;
        padding: 8px 0px;
        position: relative;

        button {
            font-size: 12px;
            color: #212121;
            letter-spacing: 0;
            width: 60px;
            height: 26px;
            padding: 0px;
            border: 1px solid rgba(229, 229, 229, 1);
            border-radius: 2px;
            position: absolute;
            left: 16px;
            top: 6px;
        }

        span {
            text-align: center;
            font-size: 16px;
            font-weight: 400;
        }
    }

    .mt-4 {
        margin-top: 4px;
    }

    .pb-16 {
        padding-bottom: 16px;
    }

    .mt-10 {
        margin-top: 10px;
    }

    .mr-20f {
        margin-right: 20%;
    }

    .mb-20 {
        margin-bottom: 20px;
    }

    .form-box {
        margin-top: 4px;
        text-align: left;


        .form-title {
            height: 40px;
            line-height: 40px;
            font-size: 16px;
            margin-left: 18px;
            font-weight: 500;
            color: #323233;
        }

        /deep/ .el-row {
            margin-left: 20px !important;
            padding-bottom: 20px;
        }
        /deep/ .el-input-number.is-without-controls .el-input__inner{
            text-align: right;
        }
        .base-box {
            display: flex;
            align-items: center;

            .label {
                font-size: 14px;
                color: #666666;
                width: 100px;
                text-align: right;
            }
        }

        .bottom-btn-box {
            padding: 18px 0px;
            text-align: center;
            border-top: 1px solid #E5E5E5;

            .el-button--primary {
                color: #ffffff;
            }
        }
    }

    .flex-between,
    .form-title-box {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .form-title-box {
        padding-right: 16px;
    }

    h2 {
        text-align: center;
        margin-bottom: 0;
    }

    .txt-right {
        text-align: right;

        span {
            margin: 0px 16px;
        }
    }

    .table1 {

        .header-div {
            background: #F2F2F2;
            font-size: 14px;
            color: #333;
            letter-spacing: 0;
            font-weight: 500;
            text-align: center;
            font-weight: 700;
            height: 32px;
            line-height: 32px;
            border: 1px solid rgba(229, 229, 229, 1);
        }

        .tab-label {
            padding: 0px 10px;
            width: 280px;
            height: 32px;
            color: #212121;
            line-height: 32px;
            background: #FAFAFA;
            border-bottom: 1px solid rgba(229, 229, 229, 1);
            border-right: 1px solid rgba(229, 229, 229, 1);
            border-left: 1px solid rgba(229, 229, 229, 1);
        }

        .tab-value {
            text-align: right;
            padding: 0px 10px;
            width: calc(100% - 320px);
            height: 32px;
            line-height: 32px;
            border-bottom: 1px solid rgba(229, 229, 229, 1);
            border-right: 1px solid rgba(229, 229, 229, 1);
            color: #666666;
        }

        p {
            color: #666666;
        }

        .line-box {
            // height: 40px;
            // line-height: 40px;
            border-bottom: 1px solid rgba(229, 229, 229, 1);

            div:first-child {
                padding: 10px 10px;
                width: 70px;
                background: #FAFAFA;
                border-right: 1px solid rgba(229, 229, 229, 1);
            }

            div:last-child {
                padding: 10px 10px;
                width: calc(100% - 160px);
                // border-top: 1px solid rgba(229, 229, 229, 1);
            }
        }
    }

    .table2,
    .table3 {
   

        td {
            padding:6px 5px;
            border: 1px solid rgba(229, 229, 229, 1);
            border-right: 0 none;
            border-top: 0 none;
        }

        th {
            border: 1px solid rgba(229, 229, 229, 1);
            border-right: 0 none;
            background: #F2F2F2;
            padding:6px 5px;
        }

        td:last-child {
            border-right: 1px solid rgba(229, 229, 229, 1);

        }

    }

    .table2 {
        margin: 16px 0px;
        width:100%;
    }

    .info-box {
        width: 390px;
        font-weight: bold;
    }

    /deep/ .el-dialog__header {
        text-align: left;
        border-bottom: 1px solid rgba(229, 229, 229, 1);
    }

    /deep/ .el-dialog__footer {
        padding: 10px 20px;
        border-top: 1px solid rgba(229, 229, 229, 1);
    }


    .flow {
        background: #fff;
        padding-left: 20px;
    }

    .iframe-sty {
        width: 100%;
        border: none;
        height: 600px;

    }

    .detail-box {
        height: auto;
        border: 1px solid rgba(229, 229, 229, 1);
        margin: 0px 16px;
        padding: 0px 16px 100px 16px;
        width:800px;
    }

    .table4 {
        padding: 0px;
    }

    .cannel-btn {
        border: 1px solid rgba(229, 229, 229, 1);
        border-radius: 2px;
        color: #212121;
    }

    .file-img-box {
        display: flex;
        align-items: center;

        img {
            width: 26px;
            height: 26px;
            margin-right: 10px;
        }

        .see-btn {
            font-size: 14px;
            color: #4FA1A4;
            letter-spacing: 0;
            line-height: 21px;
            font-weight: 400;
            cursor: pointer;
            margin-left: 10px;
        }
    }

    p {
        padding-bottom: 0px;
    }
}
.font-normal{
    font-weight: normal;
}
.total-tip{
  display: inline-block;
  margin-right: 10px;
}
.total-tip span{
  color: #FF5F1F;;
}
.duichong-img{
  position:absolute;
  top:0;
  right:0;
  width:81px;
}
.approve-img {
  position: absolute;
  top: 10%;
  right: 60px;
  width: 78px;
  height: 78px;
}
.adjust-input{
    /deep/ .el-input__inner{
        text-align:right ;
    }
}
</style>
